// extracted by mini-css-extract-plugin
export var heroImage = "_i2-1";
export var modal = "_i2-0";